import { Core, Decorative } from "@faire/design-tokens";
import { eventsThemeColors } from "@faire/web/slate/Theme/eventsThemeColors";

interface IBrandTilePromoStyle {
  lightBackground: string;
  promoText: string;
}

export const DEFAULT_BRAND_TILE_PROMO_STYLE: IBrandTilePromoStyle = {
  lightBackground: Core.surface.inverse,
  promoText: Decorative.shade.orange,
};

export const getPromoBannerStyle = (
  isLive: boolean,
  showAllSpecials: boolean,
  isHighlightedForPromotionalEvent?: boolean
): IBrandTilePromoStyle => {
  if (isHighlightedForPromotionalEvent && (isLive || showAllSpecials)) {
    return eventsThemeColors.faireMarket;
  }

  return DEFAULT_BRAND_TILE_PROMO_STYLE;
};
